// modules
import React from 'react'

// components
import Typography from 'antd/es/typography'

const { Title } = Typography

export const MaintenancePage = () => {
  return (
    <div className="maintenance">
      <img
        alt="maintenance"
        src={require('src/assets/images/screwdriver-wrench-solid.svg')}
      />

      <Title>
        Due to scheduled maintenance, the Emmacare portal and mobile App will
        not be available on 10/07/2023 from 12 to 2pm.
      </Title>
    </div>
  )
}

export default MaintenancePage
